import React from 'react';
import MultiplePublicCouponsAction
  from "@/Pages/Coupons/Assets/MultiplePublicCouponsAction/MultiplePublicCouponsAction";

const PublicCouponBottomPanel = ({checked, handleCheckAll, parentCheckbox}) => {
  return (
    <tfoot className='border-t'>
    <tr>
      <td className="px-1 pt-5 pb-4 w-1">
        <input type="checkbox" onChange={handleCheckAll} defaultChecked={false} ref={parentCheckbox}/>
      </td>
      <td>
        <MultiplePublicCouponsAction checked={checked}/>
      </td>
    </tr>
    </tfoot>
  );
};

export default PublicCouponBottomPanel;
